import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddAirline, AddNewHotel, getAirlineList, getHotelList, getSuggestList, updateAirlineStatus, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";

import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import debounce from "lodash.debounce";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";



const AddNewAirline = () => {

    const [newHotelData, setNewHotelData] = useState({
        code: "",
        name:"",
        active: "",
       
    });
    const [errors, setErrors] = useState({});
    const[loading,setLoading] = useState(false);
        const [showHotel,SetShowHotel] = useState(false);

    const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setNewHotelData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
  
    const validateForm = () => {
      const newErrors = {};
      if (!newHotelData.code) {
        newErrors.code = "Airline Code is required";
      }
      if (!newHotelData.name) {
        newErrors.name = "Airline Name is required";
      }
      if (newHotelData.active === "") {
        newErrors.active = "Status is required";
      }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
    
    const handleSubmit = () => {
        if (!validateForm()) {
          return;
        }
      
        // Create a new object instead of mutating the existing state
        const formattedData = {
          ...newHotelData,
          active: newHotelData.active === "true",
        };
      
        setLoading(true); // Show loader while the API call is being processed
      
        AddAirline(formattedData)
          .then((resp) => {
            if (resp) {
              SetShowHotel(false); // Close modal on success
              setNewHotelData({ code: "", name: "", active: "" }); // Reset form
            }
          })
          .catch((error) => {
            console.error("Error adding airline:", error);
            alert("Failed to add the airline. Please try again."); // Show user feedback
          })
          .finally(() => {
            setLoading(false); // Hide loader
          });
      };
      
    

    return(

        <>
          <div className="main_container">
       <div className="userlist_head mb-5">

     <div className="userlist_heading">
        <div className="userlist_left">
          <label>Add New Airline</label>
        </div>
        </div>
        </div>
             
         
       <div className="subadmin_container justify-between flex column gap-20" style={{width:"50%"}}>
         <div style={{padding:"30px",flex:"1 1 100%"}}>
       
       <div className="flex gap-10" style={{flex:"1 1 50%"}} >

          <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Name:</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Code"
                  name="name"
                 value={newHotelData.name}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.name && (
                  <p className="error fs-12 mt-10">{errors.name}</p>
                )}
              </div>

              <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                  <label className="fw-bold">Status:</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                   value={newHotelData.active}
                  onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">Select Status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
                    {errors.active && (
                  <p className="error fs-12 mt-10">{errors.active}</p>
                )}
                  </div>
               
          </div>
               <div className="mt-20" style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Code:</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Code"
                  name="code"
                 value={newHotelData.code}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.code && (
                  <p className="error fs-12 mt-10">{errors.code}</p>
                )}
              </div>

       
         <div className="mt-20">
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         

         </div>
       
       
         
         </div>

         </div>
        
        
        </>
    )



}
export default AddNewAirline